<!-- vdaka redirectu je mozne zachytit hook a prerusit signout -->
<template>
  <!-- template musi obsahovat nieco, takze nechat tu pradny div -->
  <div></div>
</template>
<script>
export default {
  mounted() {
    this.$store.dispatch('auth/signOut');
  },
};
</script>
